<template>
  <v-autocomplete
    :label="attributePanel ? '' : label"
    :dark="attributePanel"
    :filled="filled"
    :outlined="!filled"
    :disabled="disabled && !filled"
    dense
    :clearable="!disabled"
    :items="options"
    item-text="Name"
    item-value="Value"
    v-model="value"
    :readonly="disabled"
    @input="val => update(val)"
    :search-input.sync="search"
    return-object
    hide-details="true"
  >
  </v-autocomplete>
</template>

<script>
  import StyledSelect from '@/components/common/dropDownList/StyledSelect'
  import { searchAdvertisers } from '@/api'
  import { sortBy } from 'lodash'

  export default {
    components: {
      StyledSelect
    },
    props: {
      initialValue: null,
      disabled: {
        type: Boolean,
        default: false
      },
      attributePanel: {
        type: Boolean,
        default: false
      },
      filled: {
        type: Boolean,
        default: false
      },
      size: {
        type: Number,
        default: 1
      },
      showAdvertiserId: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: 'Advertiser'
      }
    },
    data () {
      return {
        options: [],
        isLoading: false,
        search: null,
        value: null,
        isSelected: false,
      }
    },
    mounted () {
      if (this.initialValue != null && this.initialValue.Advertiser_id) {
        this.value = this.showAdvertiserId ? { Name: `${this.initialValue.Advertiser_id} ${this.initialValue.Name}`, Value: this.initialValue } : { Name: this.initialValue.Name, Value: this.initialValue }
        this.options = [this.value]
      }
    },
    methods: {
      update (val) {
        if (!val) {
          this.isSelected = false
        } else {
          this.isSelected = true
          this.$emit('update', val.Value)
        }
      },
    },
    watch: {
      search (val) {
        if (typeof val === 'string' && val.length >= 2) {
          // Items have already been requested or selected
          if (this.isLoading || this.isSelected) return
          // Item set with initial value
          if (this.value && this.value.Name === val) return

          this.isLoading = true
          searchAdvertisers(val)
            .then(resp => {
              let sortedResults = sortBy(resp.data, obj => obj.Name).filter(obj => !!obj.Advertiser_id).map(obj => {
                if (obj.Advertiser_id) {
                  return this.showAdvertiserId ? { Name: `${obj.Advertiser_id} ${obj.Name}`, Value: obj } : { Name: obj.Name, Value: obj }
                }
              })
              this.options = sortedResults
            }).catch(resp => {
              this.options = []
            })
            .finally(() => (this.isLoading = false))
        } else if (this.initialValue) {
          this.options = [this.initialValue]
        } else {
          this.options = []
        }
      },
    },
  }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// AdvertiserSelect.vue?41bc6044